<template>
  <dropdown :y="shiftY" :x="-180" :close-on-click="true" class="submenu-map-objects-dropdown">
    <template slot="btn">
      <button @click="handleDropdownClick($event)" class="solid-list-submenu-button">
        <img @click="handleDropdownClick($event)" src="../../../files/project-menu-icon.svg" alt="menu icon" />
      </button>
    </template>

    <template slot="body">
      <ul class="submenu-list">
        <li class="submenu-list-item" @click.prevent="$emit('onFullTurnOff')">
          <span v-if="solid.exclude && parseInt(solid.exclude) != 0"> Включить в расчет</span>
          <span v-else>Отключить из расчета</span>
        </li>

        <li class="submenu-list-item" @click.prevent="$emit('onEditClick')">Изменить</li>

        <li class="submenu-list-item" @click.prevent="$emit('onRemoveClick')">Удалить</li>
      </ul>
    </template>
  </dropdown>
</template>

<script>
import Dropdown from "bp-vuejs-dropdown";

export default {
  components: {
    Dropdown,
  },
  props: {
    handleDropdownClick: Function,
    shiftY: Number,
    index: Number,
    solid: Object,
  },
};
</script>

<style scoped>
.solid-list-submenu-button {
  padding: 0;
  border: 0;
  min-width: 16px;
  width: 16px;
  height: 16px;
  background: transparent;
}
</style>
